import React from "react";
import PropTypes from "prop-types";

const StatusDisclosure = ({ children, dangerouslySetInnerHTML }) => {
  if (children) {
    return <div className="DisclosureItem__StatusDisclosure">{children}</div>;
  } else if (dangerouslySetInnerHTML) {
    return (
      <div
        className="DisclosureItem__StatusDisclosure"
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      />
    );
  }
};

StatusDisclosure.displayName = "StatusDisclosure";
StatusDisclosure.propTypes = {
  children: PropTypes.node,
  dangerouslySetInnerHTML: PropTypes.object,
};

export default StatusDisclosure;
